import * as React from "react";
import { PageContainerRow, PageTitle, HeaderRow, TitleCol, TitleColSize, centeredRowAttributes, PageContainerCol, PageContainerColLayout } from "components/Styled/Layout.Styled";
import { Row, Col } from "antd";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { ColSize } from "antd/lib/col";

declare type ColSpanType = ColSize;
export interface Props {
    children?: React.ReactNode
    title?: string;
    centered?: boolean;
    size?: ({ [key: string]: ColSpanType });
}

export interface State {
}


const TallCol = styled(Col)`
  height: 100%;
  min-height: 200px;
`;

export default class CenteredPageContainer extends React.Component<Props, State> {
    static defaultProps: Props = {
        centered: true,
    }
    constructor(props: Props) {
        super(props)

        this.state = {
        }
    }



    renderContent(centered?: boolean): React.ReactNode {

        if (centered) {
            return (
                <PageContainerRow  {...centeredRowAttributes}>
                    <PageContainerCol {...(this.props.size != undefined ? this.props.size : PageContainerColLayout)} >
                        {this.props.children}
                    </PageContainerCol>
                </PageContainerRow>
            )
        }
        else {
            return this.props.children;
        }

    }

    render() {
        return (
            <>
                <Row>
                    <Col>
                        <HeaderRow gutter={10} type='flex'>
                            <TitleCol {...TitleColSize}>
                                <PageTitle title={this.props.title}>
                                    <Helmet>
                                        <title>{this.props.title}</title>
                                    </Helmet>
                                </PageTitle>
                            </TitleCol>
                        </HeaderRow>
                    </Col>
                </Row>
                <Row type="flex" align="middle">
                    <TallCol xs={24} sm={24} md={24}>
                        {this.renderContent(this.props.centered)}
                    </TallCol>
                </Row>
            </>
        )
    }
}
